import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { DATA_SERVICE_BASE_URL } from '../config/runtime';

export default function ProductAccessPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [message, setMessage] = useState('Confirm to add ScoutCast access to your existing account.');
  const [error, setError] = useState(token ? '' : 'The confirmation link is missing its token. Open the full link from your email.');
  const [confirmed, setConfirmed] = useState(false);
  const [busy, setBusy] = useState(false);

  const confirm = async () => {
    setError('');
    setBusy(true);
    try {
      const query = new URLSearchParams({ token });
      const response = await fetch(`${DATA_SERVICE_BASE_URL}/api/users/confirm-product-access?${query}`, {
        method: 'POST',
        credentials: 'include',
      });
      const body = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(body.message || body.error || 'This confirmation link is invalid or has expired.');
      setMessage(body.message || 'ScoutCast access is confirmed. Return to the app and sign in.');
      setConfirmed(true);
    } catch (confirmationError) {
      setError(confirmationError instanceof Error ? confirmationError.message : 'Unable to confirm product access.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth">
      <section className="auth__card">
        <div className="auth__brand"><span className="auth__logo" aria-hidden>🎙️</span><span className="auth__brandName">DocuCast</span></div>
        <h1>Connect ScoutCast</h1>
        <p className="auth__tagline">{message}</p>
        {error && <div className="auth__error" role="alert">{error}</div>}
        {!confirmed && (
          <button className="btn btn--primary btn--block" type="button" disabled={!token || busy} onClick={confirm}>
            {busy ? 'Confirming…' : 'Confirm ScoutCast access'}
          </button>
        )}
        {confirmed && <p className="auth__tagline"><Link to="/login">Go to sign in</Link></p>}
      </section>
    </div>
  );
}